import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { getAssetUrl } from '../../helpers/get-asset-url';
import UskLabelSmallImageCommon from '../../img/common/usk/usk-label-small.png';
import UskLabelLargeImageHerocity from '../../img/herocity/usk/usk-label-large.png';
import UskLabelLargeImageVillage from '../../img/village/usk/usk-label-large.png';
import UskLabelLargeImageFoe from '../../img/foe/usk/usk-label-large.png';
import UskLabelLargeImageOnyx from '../../img/onyx/usk/usk-label-large.png';
import UskLabelLargeImageGrepo from '../../img/grepo/usk/usk-label-large.png';
import UskLabelLargeImageMobilecity from '../../img/mobilecity/usk/usk-label-large.png';
import styles from '../../css/components/common/uskLabel.css';
import { OneLPSsdkParamsContext } from '../../onelps-sdk-params-context';

const uskImages = {
	common: UskLabelSmallImageCommon,
};

const uskImagesLarge = {
	herocity: UskLabelLargeImageHerocity,
	village: UskLabelLargeImageVillage,
	foe: UskLabelLargeImageFoe,
	onyx: UskLabelLargeImageOnyx,
	grepo: UskLabelLargeImageGrepo,
	mobilecity: UskLabelLargeImageMobilecity
};
function UskLabelSmall({ extraStyles = '' }) {
	const onelpsParams = useContext(OneLPSsdkParamsContext);
	const gameId = onelpsParams.gameId;
	const uskImage = uskImages[gameId] || uskImages.common;
	const uskImageLarge = uskImagesLarge[gameId];
	const extraClass = extraStyles ? styles[extraStyles] : '';

	return (
		<div
			className={`${styles.uskLabelSmall} ${styles[gameId]} ${extraClass}`.trim()}
			data-testid="usk-label-small"
		>
			<img
				src={getAssetUrl() + uskImage}
				className={styles.uskImage}
			/>
			{uskImageLarge && onelpsParams.uskLabel?.hasHoverImage && (
				<img
					src={getAssetUrl() + uskImageLarge}
					className={styles.uskImageLarge}
				/>
			)}

		</div>
	);
}

UskLabelSmall.propTypes = {
	extraStyles: PropTypes.string,
};

export default UskLabelSmall;
